<template>
  <div
    v-if="direction"
    class="row q-col-gutter-sm"
  >
    <div
      :class="['col-12', {
        'col-md-8': hasChildrens,
      }]"
      v-html="direction.content"
    />
    <div
      v-if="hasChildrens"
      class="col-12 col-md-4"
    >
      <div
        v-for="(items, key) in groupedChildrens"
        :key="key"
      >
        <h3 class="type q-pb-xs">{{ $t(`pages.directions.type.${key}`) }}</h3>
        <q-list>
          <q-item
            v-for="item in items"
            :key="item.name"
          >
            <q-item-section
              v-if="item.cover_url"
              thumbnail
            >
              <q-img
                :src="resizeImage(item.cover_url, 160, 96)"
                width="160px"
              />
            </q-item-section>
            <q-item-section>
              <q-item-label class="text-bold">{{ item.name }}</q-item-label>
              <q-item-label
                class="content"
                caption
                v-html="item.content"
              />
              <q-item-label caption>
                <router-link
                  class="link"
                  :to="`/${$route.params.locale}/directions/${item.cache_path}`"
                >
                  {{ $t('button.read_more') }}
                </router-link>
              </q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ResizeImage from 'mixins/ResizeImage';

export default {
  name: 'Country',
  mixins: [
    ResizeImage,
  ],
  preFetch({ currentRoute, store, ssrContext }) {
    return store.dispatch('directions/fetchDirection', currentRoute.path.replace(/.*\/directions\//, ''))
      .then(() => {
        if (ssrContext && !store.state.directions.direction) {
          return Promise.reject({ code: 404 });
        }

        return undefined;
      });
  },
  computed: {
    ...mapGetters('directions', ['direction']),
    hasChildrens() {
      return this.direction.children.length;
    },
    groupedChildrens() {
      return this.direction.children.reduce((acc, el) => {
        (acc[el.type] = acc[el.type] || []).push(el);

        return acc;
      }, {});
    },
  },
};
</script>

<style lang="scss" scoped>
.content ::v-deep * {
  font-size: 12px;
  font-weight: 400;
  margin: 0;
}

.type {
  display: inline-block;
  border-bottom: 2px solid $primary;
}
</style>
